var map = {
	"./DJI_0028.jpg": 62301,
	"./IMG_20220817_074639.jpg": 84222,
	"./IMG_8447.png": 13054,
	"./IMG_8651.jpg": 6897,
	"./IMG_8711.jpg": 6107,
	"./moritz-kindler--SKRzGN47iQ-unsplash.jpg": 46074,
	"./raphael-cruz-IwY-27ceRCA-unsplash.jpg": 68317
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 88093;